import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const routes = {
    path: '',
    component: () =>
        import('../../../layouts/main/Main.vue'),
    children: [
        {
            path: '/helpdesk',
            name: 'helpdesk',
            beforeEnter: (to, from, next) => {
                const hasPermission = localStorage.getItem('systems').includes(to.path);
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated) next('/pages/login')
                if (hasPermission) next()
                else next('/forbidden')

            },
            component: () =>
                import('./HelpDeskView/HelpDeskView.vue')
        },
        {
            path: '/suporte_interno',
            name: 'suporte_interno',
            beforeEnter: (to, from, next) => {
                const hasPermission = localStorage.getItem('systems').includes(to.path);
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated) next('/pages/login')
                if (hasPermission) next()
                else next('/forbidden')

            },
            component: () =>
                import('./HelpDeskJira/HelpDeskJira.vue')
        },
        {
            path: '/helpdesk/new',
            name: 'helpdesk-new',
            beforeEnter: (to, from, next) => {
                const hasPermission = localStorage.getItem('systems').includes(to.path);
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated) next('/pages/login')
                if (hasPermission) next()
                else next('/forbidden')

            },
            component: () =>
                import('./HelpDeskNew/HelpDeskNew.vue')
        },
    ]
}
export default [
    routes
]

